<template>
  <div class="flex" data-testid="agency-reminder-item">
    <div class="flex flex-col items-center">
      <ReviewInteractionStatusIcon :type="ReviewInteractionType.REMINDER_CHECK" />
      <div class="mt-4 h-full border-l border-solid border-main-solid" />
    </div>
    <div class="mt-0.5 ml-2">
      <div class="mb-3 text-body-s text-subtlest">
        {{ t('Reviews.agency.review.history.datetime', { dateTime: formattedDateTime }) }}:
        <span class="text-body-s-bold">{{ t('Reviews.agency.review.history.reminderSent') }}</span>
      </div>
      <div v-if="isManual" class="mb-4 text-body-s text-subtle">
        {{ t('Reviews.agency.review.history.sender', { senderName }) }}
      </div>
      <div v-else class="mb-4 text-body-m">{{ automaticHint }}</div>
      <div v-if="isManual && reminder.message" class="bg-surface-elevation-1 p-4" v-html="nl2br(reminder.message)" />
    </div>
  </div>
</template>
<script setup lang="ts">
import { nl2br } from '@ramp106/omrjs-core-ui'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import ReviewInteractionStatusIcon from '@/components/ReviewsCommon/ReviewInteractionStatus/ReviewInteractionStatusIcon.vue'
import { ReviewInteractionType } from '@/components/ReviewsCommon/ReviewInteractionStatus/types'
import { useUserQuery } from '@/gql/myomr'
import { UniversalReviewReminderKinds } from '@/gql/reviews'

import type { UniversalReviewReminder } from './types'

const props = defineProps<{
  authorName?: string
  reminder: UniversalReviewReminder
}>()

const { t, d } = useI18n()

const isManual = computed(() => props.reminder.kind === UniversalReviewReminderKinds.Manual)

const { result } = useUserQuery(
  () => ({ userId: String(props.reminder.userId) }),
  () => ({ enabled: isManual.value && props.reminder.userId != null }),
)

const senderName = computed(() => {
  const user = result.value?.user
  if (user) {
    return [user.firstName, user.lastName].filter((x) => !!x).join(' ')
  }
  return t('Reviews.agency.review.history.unknownSender')
})

const formattedDateTime = computed(() => (props.reminder.sentAt ? d(props.reminder.sentAt, 'dateTimeShort') : ''))

const automaticHint = computed(() => {
  const authorName = props.authorName || t('Reviews.agency.reviews.table.unknownAuthor')
  return t('Reviews.agency.review.history.automaticReminderHint', { authorName })
})
</script>
